import { Form } from '@unform/web';
import axios, { AxiosError } from 'axios';
import React, { useCallback, useState } from 'react';
import Swal from 'sweetalert2';
import Input from '~/components/Input';
import InputMask from '~/components/InputMask';
import api from '~/services/api';

interface IModal {
  eventId: number;
  eventCodeId: number;
  onExecuteAudio: (type: 'success' | 'error') => void;
}

const Modal: React.FC<IModal> = ({ eventId, eventCodeId, onExecuteAudio }) => {
  const [document, setDocument] = useState('');
  const [code, setCode] = useState('');

  const handleSubmit = useCallback(
    async (dataTicket: any) => {
      try {
        const formData = {
          eventCode_id: eventCodeId,
          ticket_id: parseInt(dataTicket.code.slice(-5), 10),
          event_id: eventId,
          document: dataTicket.document,
        };

        const response = await api.post(`tickets/validate`, formData);

        // const response = await api.get(`tickets/events/${eventId}`, {
        //   params: {
        //     allStatus: true,
        //     status: ['Usado', 'Disponível', 'Cortesia'],
        //   },
        // });
        // const ticket = response.data.find(
        //   (item: any) =>
        //     item.code === dataTicket.code ||
        //     item.document === dataTicket.document
        // );

        onExecuteAudio('success');

        const successLines: string[] = [];
        successLines.push(
          `<div style="color:#fff; font-size: 20px; text-align: center;"><b>Ingresso validado com sucesso!</b></div>`
        );
        if (response.data.modality?.name) {
          successLines.push(
            `<div style="color:#fff; font-size: 16px;"><b>Modalidade:</b> ${response.data.modality.name}</div>`
          );
        }
        if (response.data.batchCategory?.category?.name) {
          successLines.push(
            `<div style="color:#fff; font-size: 16px;"><b>Categoria:</b> ${response.data.batchCategory.category.name}</div>`
          );
        }
        if (response.data.kit && typeof response.data.kit === 'object') {
          const kitEntries = Object.entries(response.data.kit)
            .map(
              ([k, v]) =>
                `<div style="color:#fff; font-size: 14px;"><b>${k}:</b> ${v}</div>`
            )
            .join('');
          if (kitEntries) {
            successLines.push(
              `<div style="margin-top:10px;"><div style="color:#fff; font-size: 16px;"><b>Kit:</b></div>${kitEntries}</div>`
            );
          }
        }

        Swal.fire({
          icon: 'success',
          title: `<span style="color: #fff;">${
            response.data.name ? response.data.name : ''
          }</span>`,
          html: `<div style="text-align:left; margin-top: 8px;">${successLines.join(
            ''
          )}</div>`,
          background: '#198754',
          iconColor: '#fff',
        });
      } catch (error) {
        onExecuteAudio('error');
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          if (err.response) {
            Swal.fire({
              icon: 'error',
              title: '<span style="color: #fff;">Opss...</span>',
              html: `<span style="color: #f8f9fa;">${err.response.data.message}</span>`,
              background: '#dc3545',
              iconColor: '#fff',
            });
          }
        } else {
          Swal.fire({
            icon: 'error',

            title: '<span style="color: #fff;">Ocorreu um erro!</span>',
            html: `<span style="color: #f8f9fa;">Tente escanear o qr code novamente</span>`,
            background: '#dc3545',
            iconColor: '#fff',
          });
        }
      }
    },
    [eventCodeId, eventId, onExecuteAudio]
  );
  return (
    <div className="px-0 py-4 p-sm-4 position-relative">
      <h2 className="mb-4">Inserir Código ou CPF manualmente</h2>
      <Form onSubmit={handleSubmit}>
        <Input
          type="number"
          name="code"
          placeholder="Código"
          onChange={(e) => setCode(e.target.value)}
        />
        <p className="text-center my-3">Ou</p>
        <InputMask
          kind="cpf"
          name="document"
          placeholder="CPF"
          className="form-control"
          inputMode="numeric"
          onChange={(e) => setDocument(e.target.value)}
        />
        <div className="d-flex align-items-center">
          <button
            type="button"
            onClick={() => Swal.close()}
            className="mx-2 h5 btn btn-secondary w-100 py-2 mt-4"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={!code && !document}
            className="mx-2 h5 btn btn-primary w-100 py-2 mt-4"
          >
            Enviar
          </button>
        </div>
      </Form>
    </div>
  );
};

export default Modal;
